/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Input, Modal } from 'antd';
import { t } from 'i18next';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MyCompanyService from '../../../../services/MyCompany.service';
import useNotify from '../../../../context/Notification/useNotify';

export default function ModalAddDomain({
    open,
    handelClose,
    setDomainId,
    domainId,

    domainDetail,
    setModalMode,
}) {
    const [form] = Form.useForm();
    const { id } = useParams();
    const notify = useNotify();

    const onFinish = async (value) => {
        if (!domainId) {
            try {
                const { data } = await MyCompanyService.createDomain({
                    ...value,
                    companyId: id,
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully saved data'),
                    });
                    setModalMode('success');
                    handelClose();
                    setDomainId('');
                } else {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                    handelClose();
                    setDomainId('');
                }
            } catch (error) {
                if (error?.data?.errorData?.msg === 'DUPLICATE DOMAIN NAME') {
                    form.setFields([
                        {
                            name: 'domainName',
                            errors: [t('MyCompany.ThisDomainIsExist')],
                        },
                    ]);
                } else {
                    handelClose();
                    setDomainId('');
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                }
            }
        } else {
            try {
                const { data } = await MyCompanyService.updateDomain({
                    ...value,
                    companyId: id,
                    domainId: domainId,
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to submitted'),
                    });
                    setModalMode('success');
                    handelClose();
                    setDomainId('');
                } else {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                    handelClose();
                    setDomainId('');
                }
            } catch (error) {
                if (error?.data?.errorData?.msg === 'DUPLICATE DOMAIN NAME') {
                    form.setFields([
                        {
                            name: 'domainName',
                            errors: [t('MyCompany.ThisDomainIsExist')],
                        },
                    ]);
                } else {
                    handelClose();
                    setDomainId('');
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                }
            }
        }
    };

    useEffect(() => {
        if (domainId) {
            form.setFieldsValue({
                ...domainDetail,
            });
        }
    }, [domainId, domainDetail]);

    return (
        <>
            <Modal
                afterClose={() => {
                    form.resetFields();
                    setDomainId();
                }}
                className="_modal"
                footer={false}
                open={open}
                closable={false}
                onCancel={() => {
                    handelClose();
                    form.resetFields();
                }}
            >
                <div className="text-center text-1xl font-normal pb-[30px]">
                    {domainId
                        ? t('MyCompany.EditWebsiteDomain')
                        : t('MyCompany.AddWebsiteDomain')}
                </div>
                <div>
                    <Form form={form} layout="vertical" onFinish={onFinish}>
                        <Form.Item
                            extra={t('MyCompany.ExtraDomainName')}
                            label={t('COOKIE.DomainName')}
                            name="domainName"
                            rules={[
                                {
                                    required: true,
                                    message: t('errorText.requiredField'),
                                },
                                {
                                    pattern: new RegExp(
                                        /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi
                                    ),
                                    message: t('MyCompany.DomainNotValid'),
                                },
                            ]}
                        >
                            <Input
                                showCount
                                size="large"
                                maxLength={100}
                                placeholder={t('COOKIE.DomainName')}
                            />
                        </Form.Item>
                        <div className="flex justify-center space-x-3 pt-16">
                            <div>
                                <Button
                                    size="large"
                                    onClick={() => {
                                        handelClose();
                                        setDomainId('');
                                        form.resetFields();
                                    }}
                                    className="border-[#7B67FB] text-[#7B67FB] w-[120px]"
                                    type="default"
                                >
                                    {t('common.Cancel')}
                                </Button>
                            </div>
                            <div>
                                <Button
                                    className="w-[120px]"
                                    htmlType="submit"
                                    size="large"
                                    type="primary"
                                >
                                    {t('common.Save')}
                                </Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal>
        </>
    );
}
